import { render } from "./Indbydelse.vue?vue&type=template&id=15a812e7"
const script = {}
script.render = render

export default script